//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export const IMAGE_TIMESTAMP_PARAM = 't';

export const MAX_IMAGE_SIZE_MB = 5;
export const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;
